import React from "react";

import { Confirm } from "../index";
import { info } from "../../../assets/dark-theme";

import {InfoCircleFilled} from '@ant-design/icons';

import "./informationPopup.scss";

// Translation-
import { useTranslation } from 'react-i18next';

interface InformationPopUpProps {
  className?: string;
  title?: string;
  content?: string | React.ReactNode;
  style?: React.CSSProperties;
}


const InformationPopUp = ({ className = "", title = "", content = "", style = {} }: InformationPopUpProps) => {
    // Translation-
    const { t } = useTranslation();

  const onShowPopup = () => {
    Confirm({
      title:title,
      icon: <InfoCircleFilled style={{color: '#006b8c'}}/>,
      content: content,
      onOk: () => {},
      okText: t('common.Ok'),
      onCancel: () => {},
      className: className,
    });
  };
  return (
    <div className="toolbar-help" style={style}>
      <img src={info} alt="help" onClick={onShowPopup} className="helpIcon" />
    </div>
  );
};

export default InformationPopUp;
